<template>
  <div class="zv-page">
    <div class="zv-content">
        <div class="zv-block">
          <div class="zv-breadcrumb-wrap">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/data-analysis/areaList' }">地区库管理</el-breadcrumb-item>
              <el-breadcrumb-item>{{ isEdit ? '编辑地区库' : '新建地区库' }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <el-form ref="myForm" :model="formData" :rules="formRules" :label-width="formLabelWidth">
              <el-form-item label="地区名称：" prop="area_name">
                <el-input v-model="formData.area_name" clearable placeholder="请输入地区名称" style="width: 300px"></el-input>
              </el-form-item>

              <el-form-item label="英文名称：" prop="area_english_name">
                <el-input v-model="formData.area_english_name" clearable placeholder="请输入地区英文名称" style="width: 300px"></el-input>
              </el-form-item>

              <el-form-item label="上级地区：" prop="parent_area_id">
                <el-select
                  v-model="formData.parent_area_id"
                  filterable
                  clearable
                  placeholder="请选择上级地区"
                  style="width: 300px"
                >
                  <el-option
                    v-for="item in areaListData"
                    :key="item.id"
                    :label="item.area_name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="地区类别：" prop="area_type">
                <el-select
                  v-model="formData.area_type"
                  filterable
                  clearable
                  placeholder="请选择地区类别"
                  style="width: 300px"
                >
                  <el-option
                    v-for="item in areaTypeData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="经度lon：" prop="longitude">
                <el-input v-model="formData.longitude" placeholder="请输入经度" clearable style="width: 300px"></el-input>
              </el-form-item>
              <el-form-item label="纬度lat：" prop="latitude">
                <el-input v-model="formData.latitude" clearable placeholder="请输入纬度" style="width: 300px"></el-input>
              </el-form-item>

              <el-form-item label="经纬度来源：">
                <el-select v-model="formData.coordinate_type" filterable style="width: 300px" clearable placeholder="请选择">
                  <el-option
                    v-for="item in coordinateArr"
                    :key="item.id"
                    :label="item.label"
                    :value="item.label"
                    >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="hc_key：" prop="hc_key">
                <el-input v-model="formData.hc_key" clearable placeholder="请输入hc_key" style="width: 300px"></el-input>
              </el-form-item>

              <el-form-item label="地图边界数据：">
                <div style="float: left">
                  <a :href="formData.geojsonfile" target="_blank">{{jsonName || formData.geojson}}</a>
                </div>
                <div style="float: left;margin-left: 20px">
                  <el-upload
                    :action="uploadUrl"
                    accept="*"
                    :show-file-list="false"
                    :data="uploadExtraData"
                    name="file"
                    v-model="formData.geojsonfile"
                    :on-success="handleUploadSuccess"
                  >
                    <span style="color: #3ae2c4">上传</span>
                  </el-upload>
                </div>
              </el-form-item>
              
              <el-form-item label="启用地图：" prop="show_map">
                <el-switch
                  v-model="formData.show_map"
                  :inactive-value="0"
                  :active-value="1"
                ></el-switch>
              </el-form-item>

              <el-form-item label="重点地区：" prop="is_import">
                <el-switch
                  v-model="formData.is_import"
                  :inactive-value="0"
                  :active-value="1"
                ></el-switch>
              </el-form-item>

              <el-form-item label="支持风险监测：" prop="risk_monitor">
                <el-switch
                  v-model="formData.risk_monitor"
                  :inactive-value="0"
                  :active-value="1"
                ></el-switch>
              </el-form-item>

              <div v-if="isEdit">
                <el-form-item v-if="formData.risk_score" label="风险指数：">
                  <span>{{formData.risk_score}}</span>
                  <span style="color: rgb(58 226 196);margin-left: 20px" @click="goInter">干预</span>
                </el-form-item>
                <el-form-item v-if="formData.risk_type_score_top3.length > 0" label="主要风险及分数：">
                  <div v-for="(item,index) in formData.risk_type_score_top3" :key="index">{{item.risk_name}}（{{item.score}}）<span v-if="index == 0" style="color: rgb(58 226 196);margin-left: 20px" @click="goInter">干预</span></div>
                </el-form-item>
              </div>

              <el-form-item label="地区风险情况：" prop="show_risk_info">
                <el-switch
                  v-model="formData.show_risk_info"
                  :inactive-value="0"
                  :active-value="1"
                ></el-switch>
              </el-form-item>

              <div v-if="formData.show_risk_info == 1">
                <el-form-item label="风险描述：" prop="risk_descr">
                  <el-input v-model="formData.risk_descr" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入风险描述" clearable style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="华人风险描述：" prop="chinese_risk_descr">
                  <el-input v-model="formData.chinese_risk_descr" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入华人风险描述" clearable style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="风险评价：" prop="risk_appraise">
                  <el-input v-model="formData.risk_appraise" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入华人风险描述" clearable style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="风险评价详情：" prop="risk_appraise_detail">
                  <el-input v-model="formData.risk_appraise_detail" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入华人风险描述" clearable style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="应对建议：" prop="response_suggestions">
                  <el-input v-model="formData.response_suggestions" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入华人风险描述" clearable style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="出行建议：" prop="travel_suggestions">
                  <el-input v-model="formData.travel_suggestions" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入华人风险描述" clearable style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="对华政策：" prop="china_policy">
                  <el-input v-model="formData.china_policy" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入华人风险描述" clearable style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="贸易风险/政策：" prop="business_risk_policy">
                  <el-input v-model="formData.business_risk_policy" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入华人风险描述" clearable style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="其他风险：" prop="other_risk">
                  <el-input v-model="formData.other_risk" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入华人风险描述" clearable style="width: 300px"></el-input>
                </el-form-item>
              </div>
            
            <el-form-item label-width="auto" class="fi-flex-center paddint-t-30">
              <el-button @click="goBack">返回</el-button>
              <el-button type="primary" @click="doSubmit">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
</template>

<script>
import api from './api';
import formPageMixin from "@/mixins/formPageMixin";
import addFormMixin from "@/mixins/addFormMixin";
import TipUtil from "@/utils/utils/TipUtil";
import EventBus from "@/utils/services/event_service";
import { BaseUrl } from "@/main_config"
import tokenService from "@/utils/services/token_service"

export default {
  name: "CreateModel",
  mixins: [formPageMixin, addFormMixin],
  components: {
  },
  data() {
    let vm = this;
    return {
      id: '',   // 事件编辑时id
      isEdit: false,   // 是否为编辑
      formDataOri: {
        area_name: '',  // 地区名字
        parent_area_id: '',  // 上级地区ID（顶级是0）
        area_type: '',    // 地区类别 1 洲 2 国 3省 4市
        longitude: '',
        latitude: '',
        hc_key: '',
        is_import: '',
        show_risk_info: ''
      },
      jsonUrl: '',
      jsonName: '',
      uploadUrl: BaseUrl + '/api.php?do=admin_file_upload',
      uploadExtraData: {
        type: 3,
        dir: 'geojson',
        sid: tokenService.getToken()
      },
      coordinateArr: [
        { label: '谷歌地图（国内）', id: 1 },
        { label: '谷歌地图（国外）', id: 2 },
        { label: '百度地图', id: 3 },
        { label: '高德地图', id: 4 },
        { label: '腾讯地图', id: 5 },
        { label: '天地图', id: 6 }
      ],
      formRules: {
        area_name: [{
          required: true,
          message: "地区名称不能为空",
          trigger: "blur"
        }],
        parent_area_id: {
          required: true,
          message: "上级地区不能为空",
          trigger: "change"
        },
        area_type: {
          required: true,
          message: "地区类别不能为空",
          trigger: "change"
        },
        latitude: {
          required: true,
          message: "经度不能为空",
          trigger: "blur"
        },
        longitude: {
          required: true,
          message: "纬度不能为空",
          trigger: "blur"
        },
      },
      areaListData: [],   // 全部区域
      areaTypeData: vm.$enums.AreaType.list,   // 区域类型数据
    };
  },
  computed: {
    
  },

  methods: {
    async getAreaListData() {
      let res = await api.areaList({
        page: 1,
        pagesize: this.$enums.allPageSize
      })
      console.log(res)
      let filterData = res.list.filter(item => item.area_type != 4)
      filterData.unshift({
        id: 0,
        area_name: '顶级'
      })

      this.areaListData = filterData
    },

    async initEditData() {
      let resData = await api.InfoArea({
        id: this.id
      })
      console.log(resData)
      this.formData = resData.info
      this.$set(this.formData,"geojsonfile","http://yjapi.ciwei.com/geojson/" + resData.info.geojson)
    },

    doSubmit() {
      this.$refs.myForm.validate(async valid => {
        if (!valid) {
          TipUtil.message('请检查表单!', 'warning')
          return
        }else {
          console.log(this.formData)
          let apiFunc = this.isEdit ? api.editArea : api.addArea
          let res = await apiFunc(this.formData)
          let msg = this.isEdit ? '修改地区库成功' : '新增地区库成功'
          TipUtil.message(msg, "success")
          setTimeout(() => {
            this.$router.push('/data-analysis/areaList')
          }, 200)
        }
      })
    },

    // json上传
    handleUploadSuccess(res, file) {
      console.log(file)
      this.jsonName = file.name
      this.formData.geojsonfile = res.file
      this.$set(this.formData,"show_map",1)
    },
    // 1.4新增跳转去干预
    goInter() {
      let pattern_id = this.formData.area_type == 2? 2: this.formData.area_type == 3 ? 3:this.formData.area_type == 4? 6: ""
      let routeData = this.$router.resolve('/data-analysis/ConfigModelIntervene?pattern_id='+pattern_id+'&area_type='+this.formData.area_type+'&area_id='+this.formData.id+'')
      window.open(routeData.href, '_blank');
    }
  },
  created() {
    this.getAreaListData()
    let id = this.$route.query.id
    if (id) {
      this.id = id
      this.isEdit = true
    }
    if (this.isEdit) {
      this.initEditData();
    } else {
      // this.initAddData();
    }
  },
  mounted() {
    let vm = this
    EventBus.$off('updateModelItemData').$on('updateModelItemData', function(itemData) {
      vm.updateModelItemData(itemData);
    })
  },
  beforeDestroy() {
    EventBus.$off('updateModelItemData')
  }
};
</script>

<style lang="less" scoped>

</style>
